import { ReactNode } from 'react';
import { Card, withStyles } from 'vopay';
import { Title } from 'UI';
import styles from './RecurringPaymentCard.module.scss';

const cn = withStyles(styles);

export type RecurringPaymentCardProps = {
  title: string;
  children: ReactNode;
};

// Generic "Recurring Payment" card shell — shared by every non-one-time Recurrence preset
// (not just Custom), each of which slots its own preset-specific fields in as children,
// always followed by RecurrenceEndsField. Kept import-free of any consumer's field vocabulary
// so it can be reused as-is for eLinx (buildElinxRows.helper.tsx) later.
export default function RecurringPaymentCard({ title, children }: RecurringPaymentCardProps) {
  return (
    <Card className={cn('card')} hoverEffect={false}>
      <Title level="4">{title}</Title>
      {children}
    </Card>
  );
}
